const rules = {
  authEmail: {
    required: true,
    email: true, // disable the default
    // Email regex pattern
    /* eslint-disable-next-line no-useless-escape */
    pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  },
}

export default rules;